import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ChatWidgetComponent } from 'src/app/shared/components/widgets/chat-widget/chat-widget.component';

@Component({
  selector: 'app-footer-more-info',
  standalone: true,
  imports: [ChatWidgetComponent],
  templateUrl: './footer-more-info.component.html',
  styleUrl: './footer-more-info.component.scss'
})
export class FooterMoreInfoComponent {
currentYear = new Date().getFullYear();
  constructor(private router:Router){

  }

goTo(link:any){
   this.router.navigate([link])
}

}
